export const dashboardCoreBlocks = [
  {
    title: 'Aides',
    subtitle: 'Trouve les aides que tu laisses peut-etre passer.',
    value: 'Quiz + droits',
    path: '/dashboard/aides',
    testId: 'card-core-aides',
  },
  {
    title: 'Declarations',
    subtitle: 'Verifie, complete et optimise ta declaration.',
    value: 'Checklist fiscale',
    path: '/dashboard/assistant-fiscal',
    testId: 'card-core-declarations',
  },
  {
    title: 'Abonnements',
    subtitle: 'Repere les doublons, renouvellements et economies.',
    value: 'Economies possibles',
    path: '/dashboard/abonnements',
    testId: 'card-core-abonnements',
  },
];

export const dashboardNavItems = [
  { label: 'Copilote', path: '/dashboard' },
  { label: 'Démarches', path: '/dashboard/demarches' },
  { label: 'Mon profil', path: '/dashboard/profil' },
  { label: 'Mes actions', path: '/dashboard/tasks' },
  { label: 'Documents', path: '/dashboard/documents' },
  { label: 'Configuration', path: '/dashboard/configuration' },
];

export const accountConfigurationItems = [
  {
    label: 'Compte bancaire',
    detail: 'Connexion bancaire et import des mouvements pour les économies détectées.',
    status: 'planned',
  },
  {
    label: 'Email',
    detail: 'Connexion mail pour repérer abonnements, renouvellements et justificatifs.',
    status: 'planned',
  },
  {
    label: 'Comptes officiels',
    detail: 'Impots.gouv, CAF et autres espaces officiels pilotés par le copilote.',
    status: 'planned',
  },
  {
    label: 'Preferences de rappels',
    detail: 'Échéances fiscales, renouvellements et relances administratives.',
    status: 'planned',
  },
];
